import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import Popover from '@material-ui/core/Popover';
import { Helmet } from 'react-helmet';

import NavBar from '../nav/NavBar';
import Footer from '../footer/Footer';
import FooterSpacer from '../footer/FooterSpacer';

import Hero from '../../static/img/diversity_commitment_page/diversity-hero.png';
import diversityImg from '../../static/img/diversity_commitment_page/diversity-section.png';
import weCommitTo from '../../static/img/diversity_commitment_page/we-commit-to.png';
import quote from '../../static/img/diversity_commitment_page/quote-img.png';
import resourcesPDF from '../../static/docs/Resources to support Race Education & Literacy.pdf';

const text = {
  commitmentTitle: 'Nia\'s Commitment',
  commitmentBody1: 'Over 35 years ago, Nia was founded to bring greater health and well-being of Body, Mind, Emotions and Spirit to all people. Our focus and intent has always been for Nia to be a rich, diverse and inclusive community for every age, size, shape, gender, ability, race and ethnicity, nationality, sexual orientation, faith, belief system and all of the other beautiful qualities that make each individual body and spirit unique.',
  commitmentBody2: 'We recognize this is a long journey that will never be complete. Below we have outlined our commitments to long-term initiatives supporting the ongoing evolution of Nia as a brand, practice, and community.',
  diversityTitle: 'Celebrate Diversity',
  diversityBody1: 'Nia includes and celebrates people of all races, ethnicities, ages, gender identities, sexual orientations, family structures, body shapes/sizes, religions, cultures, castes, tribes, socio-economic statuses, and physical and cognitive abilities.',
  diversityBody2: ' that celebrating the diversity and uniqueness of all our varied identities makes us stronger and better able to serve each other and the world.',
  diversityBody3: ' to continually strive to ensure that Nia classes, workshops and trainings are spaces that value, uplift and nurture the diversity, uniqueness and contributions of all people. ',
  diversityBody32: ' to continually strive to reflect and celebrate this diversity in Nia materials, websites, routines, music, NiaWear, and Nia On Demand.',
  equityTitle: 'BOOST EQUITY',
  equityBody1: ' in creating a more equitable world. We acknowledge that historical advantages and barriers exist, and, as a result, we don’t all start from the same place. Equity seeks to redress these imbalances. Equity thrives in an environment built on respect and dignity by balancing access to information, resources and opportunities.',
  equityBody2: ' to creating a Nia community that seeks to remove the cultural, economic, historical, physical and attitudinal barriers that have denied access to wellness, healing, and communal support for ALL BODIES. We will proactively create opportunities and assistance for Nia students, teachers and trainers to foster a level playing field.',
  awarenessTitle: 'INCREASE AWARENESS',
  awarenessBody1: ' Nia teachers, trainers and leadership hold a sacred responsibility of co-creating and holding the space for the healing and well-being of all students.',
  awarenessBody2: ' to providing education and resources to Nia teachers, trainers and leadership to increase awareness and ensure that each facilitator is equipped with the knowledge and understanding needed to provide a warm, welcoming, and transformative environment that supports every student to feel embraced, respected, and valued in their uniqueness.',
  communityTitle: 'CO-CREATE COMMUNITY',
  communityBody1: ' that the highest potential for Nia to manifest our purpose as a practice and organization is realized through the collective contributions and collaboration of the community as a whole.',
  communityBody2: ' to fostering a culture of community and co-creation that honors a diversity of beliefs, identities and cultures, and invites the collaboration, contribution and participation of all.',
  evolvingBody1: 'As of March 2022, The structure of DEI at Nia is evolving as we seek outside council and direction. We look forward to exploring new opportunities to invite more voices and contributions to continue our commitments to evolving Diversity, Equity and Inclusion throughout Nia.',
  evolvingBody2: 'We want to express our sincere thanks to all members who served on the DEI Advisory Council from August 2020 to February 2022 for your heartfelt, committed service.',
  quote: 'Start where you are. Use what you have. Do what you can.',
  quoteAuthor: 'Arthur Ashe',
  commitmentFooterBold: 'These are the first steps on our path.',
  commitmentFooter: 'Creating change will require sustained commitment. Nia’s purpose is to help people reach their greatest potential and heal the world one body at a time. We know this can only happen in an environment where everybody has an equal opportunity to heal. We are committed to doing our part.',
  educateButton: 'Race Education + Literacy Resources',
};

const styles = theme => ({
  appBarSpacer: theme.mixins.toolbar,
  bottom: {
    paddingBottom: theme.spacing(6),
  },
  page: {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    backgroundColor: 'white',
  },
  container: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(800 + theme.spacing(2 * 2))]: {
      width: 800,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  divider: {
    [theme.breakpoints.down(600)]: {
      width: '15vw',
    },
    width: '5vw',
    margin: 'auto',
    border: '1px solid grey',
    marginBottom: theme.spacing(4),
  },
  educateButton: {
    textAlign: 'center',
    marginBottom: theme.spacing(5),
  },
  hero: {
    height: 'auto',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    marginTop: theme.spacing(4),
  },
  heroImg: {
    height: 'auto',
    width: '100%',
  },
  section: {
    padding: theme.spacing(5),
  },
  sectionGrey: {
    padding: theme.spacing(5),
    backgroundColor: '#f4f4f4',
  },
  sectionText: {
    paddingBottom: theme.spacing(6),
  },
  sectionTextPadTop: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(6),
  },
  sectionHeader: {
    fontSize: '3.75rem',
    [theme.breakpoints.down(600)]: {
      fontSize: '1.4em',
    },
    marginBottom: theme.spacing(6),
    letterSpacing: '3px',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  teamMemberContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    textAlign: 'center',
    justifyContent: 'space-around',

  },
  teamMember: {
    paddingBottom: theme.spacing(4),
  },
  teamSubHeader: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4),
    fontSize: '1.5em',
    letterSpacing: '3px',
    textTransform: 'uppercase',
  },
  titleImg: {
    maxWidth: '100%',
  },
  quoteContainer: {
    paddingBottom: theme.spacing(4),
  },
  quoteAuthor: {
    textAlign: 'right',
  },
  iconButton: {
    height: '180px',
    width: '180px',
  },
  img: {
    height: '160px',
    width: '160px',
  },
  popOver: {
    // maxWidth: '500px',
  },
  popOverText: {
    padding: theme.spacing(2),
  },
  memberName: {
    maxWidth: '180px',
  },
});


class DEICommitmentPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      bio: null,
    };

    this.handleClose = this.handleClose.bind(this);
    this.handlePopOver = this.handlePopOver.bind(this);
  }

  handlePopOver(e, bio) {
    this.setState({
      anchorEl: e.currentTarget,
      bio,
    });
  }

  handleClose() {
    this.setState({
      anchorEl: null,
    });
  }

  render() {
    const { anchorEl, bio } = this.state;
    const { classes } = this.props;

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    return (
      <div className={classes.page}>

        <Helmet>
          <title>Diversity Equity & Inclusion Commitments | Nia</title>
          <meta name="description" content="Learn about our DEI commitments here." />
          <meta name="keywords" content="" />
        </Helmet>

        <NavBar />
        <main className={classes.container}>
          <div className={classes.appBarSpacer} />
          <div className={classes.content}>
            <div className={classes.hero}>
              <img className={classes.heroImg} alt="Class Page Hero" src={Hero} />
            </div>
            <div className={classes.section}>
              <Typography className={classes.sectionHeader} color="textSecondary" variant="h1">{text.commitmentTitle}</Typography>
              <div className={classes.divider} />
              <Typography className={classes.sectionText} variant="body1">{text.commitmentBody1}</Typography>
              <Typography className={classes.sectionText} variant="body1">{text.commitmentBody2}</Typography>
              <img className={classes.titleImg} src={weCommitTo} alt="we commit to" />
            </div>
            <div className={classes.sectionGrey}>
              <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">{text.diversityTitle}</Typography>
              <div className={classes.divider} />
              <img className={classes.heroImg} src={diversityImg} alt="hands coming together" />
              <Typography className={classes.sectionTextPadTop} variant="body1">{text.diversityBody1}</Typography>
              <Typography className={classes.sectionText} variant="body1"><strong>We believe</strong>{text.diversityBody2}</Typography>
              <Typography className={classes.sectionText} variant="body1"><strong>We commit</strong>{text.diversityBody3}<strong>We commit</strong>{text.diversityBody32}</Typography>
              <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">{text.equityTitle}</Typography>
              <div className={classes.divider} />
              <Typography className={classes.sectionText} variant="body1"><strong>We believe</strong>{text.equityBody1}</Typography>
              <Typography className={classes.sectionText} variant="body1"><strong>We commit</strong>{text.equityBody2}</Typography>
            </div>
            <div className={classes.section}>
              <div>
                <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">{text.awarenessTitle}</Typography>
                <div className={classes.divider} />
                <Typography className={classes.sectionText} variant="body1"><strong>We believe</strong>{text.awarenessBody1}</Typography>
                <Typography className={classes.sectionText} variant="body1"><strong>We commit</strong>{text.awarenessBody2}</Typography>
                <div className={classes.educateButton}>
                  <Button className={classes.educateButton} variant="outlined" href={resourcesPDF}>{text.educateButton}</Button>
                </div>
                <Typography className={classes.sectionHeader} color="textSecondary" variant="h2">{text.communityTitle}</Typography>
                <div className={classes.divider} />
                <Typography className={classes.sectionText} variant="body1"><strong>We believe</strong>{text.communityBody1}</Typography>
                <Typography className={classes.sectionText} variant="body1"><strong>We commit</strong>{text.communityBody2}</Typography>
              </div>
            </div>
            <div className={classes.sectionGrey}>
              <Grid container className={classes.quoteContainer}>
                <Grid item xs={3}>
                  <img className={classes.titleImg} src={quote} alt="quote" />
                </Grid>
                <Grid item xs={9}>
                  <Typography color="textSecondary" variant="h5">{text.quote}</Typography>
                  <Typography className={classes.quoteAuthor} color="textSecondary" variant="subtitle1">{`-${text.quoteAuthor}`}</Typography>
                </Grid>
              </Grid>
              <div className={classes.divider} />
              <Typography className={classes.bottom} variant="body1">
                <strong>{text.commitmentFooterBold + ' '}</strong>
                {text.commitmentFooter}
              </Typography>
            </div>
          </div>
          <FooterSpacer />
        </main>
        <Footer />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={this.handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          PaperProps={{
            style: { maxWidth: '400px' },
          }}
        >
          <Typography className={classes.popOverText}>{bio}</Typography>
        </Popover>
      </div>
    );
  }
}

DEICommitmentPage.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DEICommitmentPage);
